export default __webpack_public_path__ + "static/media/lessThanOrEqualTo.9eac2ee8.svg";